module.exports = __webpack_public_path__ + "static/media/cert_106.546f3094.jpg";